import {
  createBrowserRouter,
  createRoutesFromElements,
  Route,
} from "react-router-dom";
import { NotFound } from "./common";
import { CheckVendor } from "./common";
import { callVendorAPI } from "./components/CustomerPage";
import {
  CheckVendorBses,
  getBsesCustomerDetails,
} from "./bses/components/check_valid_ca";
import UnionPage from "./cbdt/union/components/main";
import { getTransactionData } from "./cbdt/union/components/main";
import { getTransactionStatusUnion } from "./cbdt/union/components/main";
import { fetchTransactionDataTG } from "./tgspdcl/components/main";
import ChargesPage from "./cbdt/union/components/charges";
import ServicePage from "./andhra/components/ServiceNumber";
import StatusPage from "./andhra/components/StatusPage";
import UniqueServicePageTGN from "./tgnpdcl/components/UniqueServiceNumberTGN";
import StatusPageTGN from "./tgnpdcl/components/StatusPageTGN";
import { fetchTransactionDataTGN } from "./tgnpdcl/components/main";

import ServicePageTG from "./tgspdcl/components/ServiceNumberTG";
import StatusPageTG from "./tgspdcl/components/StatusPageTG";

const RoutesConfig = createBrowserRouter(
  createRoutesFromElements(
    <Route path="/" errorElement={<NotFound />}>
      <Route index element={<NotFound />} />
      <Route
        path="bses/:region/"
        element={<CheckVendorBses />}
        errorElement={<NotFound />}
        loader={getBsesCustomerDetails}
      />
      <Route
        path="emeter/:vendor_name"
        element={<CheckVendor />}
        errorElement={<NotFound />}
        loader={callVendorAPI}
      />
      <Route
        path="APCPDCL/Billpay"
        element={<ServicePage />}
        errorElement={<NotFound />}
      />
      <Route
        path="APCPDCL/:txn_id"
        element={<StatusPage />}
        errorElement={<NotFound />}
      />
      <Route
        path="TGSPDCL/Billpay"
        element={<ServicePageTG />}
        errorElement={<NotFound />}
      />
      <Route
        path="TGSPDCL/:txn_id"
        element={<StatusPageTG />}
        errorElement={<NotFound />}
        loader={fetchTransactionDataTG}
      />
      <Route
        path="cbdt/union/:transaction_id"
        element={<UnionPage />}
        errorElement={<NotFound />}
        loader={getTransactionData}
      />
      <Route
        path="cbdt/union/:transaction_id/:txn"
        element={<UnionPage />}
        errorElement={<NotFound />}
        loader={getTransactionStatusUnion}
      />
      <Route
        path="cbdt/union/error/"
        element={<NotFound />}
        errorElement={<NotFound />}
        loader={getTransactionData}
      />
      <Route
        path="cbdt/charges"
        element={<ChargesPage />}
        errorElement={<NotFound />}
        loader={getTransactionData}
      />
      <Route path="*" element={<NotFound />} />
      <Route
        path="TGNPDCL/Billpay"
        element={<UniqueServicePageTGN />}
        errorElement={<NotFound />}
      />
      <Route
        path="TGNPDCL/:txn_id"
        element={<StatusPageTGN />}
        errorElement={<NotFound />}
        loader={fetchTransactionDataTGN}
      />
    </Route>
  )
);

export default RoutesConfig;
